import React, { useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "../../../../components2/YhBox";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { IBranchDetail } from "../dataBranchTypes";
import { useDataBranchModel } from "../dataBranchModel"
import { DetailType } from "../../../../types/FmsEnums";
import { useNavModel } from "../../../../model/navModel";
import { globalPrompt } from "../../../../components2/YhMessage"

const BranchList = () => {
    const { dataSource, page, selectedRowKeys, selectedRow, loadSelectData, loadData, setSelectedRowKeys, setSelectedRow } = useDataBranchModel()
    const { addNav } = useNavModel()

    useEffect(() => {
        loadData()
        loadSelectData()
    }, [])
    const columns: ColumnsType<IBranchDetail> = [
        {
            title: '序号',
            render: (text, record, index) => `${index + 1}`
        },
        {
            title: '分支编码',
            dataIndex: 'code',
        },
        {
            title: '分支名称',
            dataIndex: 'name',
        },
        {
            title: '数据目录编码',
            dataIndex: 'catalog',
        },
        {
            title: '备注',
            dataIndex: 'status',
            render: (text) => text ? "关闭" : "开启"

        }
    ];
    const onDetail = (type: string) => {
        const id = selectedRowKeys[0] as string //这里做类型转换

        switch (type) {
            case DetailType.add:
                return addNav("1-2-1", { id: "", mode: type })
            case DetailType.edit:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要编辑的数据" })
                return addNav("1-2-2", { id, mode: type });
            case DetailType.look:
                if (selectedRowKeys.length == 0) return globalPrompt("message", { type: "error", text: "选择您要查看的数据" })
                return addNav("1-2-3", { id, mode: type });
            default:
                return false
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("add")}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("edit")}
        >编辑</Button>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onDetail("look")}
        >查看</Button> */}
    </>
    const rowSelection = {
        onChange(selectedRowKeys: React.Key[], selectedRows: IBranchDetail[]) {
            setSelectedRowKeys(selectedRowKeys)
        },
        selectedRowKeys
    }
    const onRow = (record: IBranchDetail) => {
        return {
            onClick: () => {
                if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                    setSelectedRowKeys([])
                    setSelectedRow({})
                } else {
                    setSelectedRowKeys([record.key as string])
                    setSelectedRow(record)
                }
            },
        }
    }
    return (
        <YhBox action={action}>
            <Table
                columns={columns}
                dataSource={dataSource}
                rowSelection={{
                    type: "radio",
                    ...rowSelection
                }}
                onRow={onRow}
                pagination={{
                    ...page,
                    position: ["bottomCenter"],
                    showTotal: () => `共${page.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}
export default BranchList